import React from 'react';
import { IAllForColumnX, IGalleryList, IOneGallery } from './Common';
import Column4 from './Column4';
import ImageUtil from '../../utils/image';
import { inject, observer } from "mobx-react";

interface IAllForColumn4 extends IAllForColumnX {}
const AllForColumn4 = function(props: IAllForColumn4) {
  const { list, jigsaw } = props;

  const { wxuserStore } = props.rootStore!;
  const { currentPayedImages } = wxuserStore;

  return (
    <div className="rows gallery-list" style={{ padding: 0 }}>
      {list.map((one,index) => {
        let { id, hash, galleryid} = one;
        return (
          <Column4
            id={id}
            jigsaw={jigsaw}
            key={id}
            index={one.index}
            isPayed={currentPayedImages[String(id)]}
            hidePayedTag={one.hidePayedTag}
            src={ImageUtil.style(hash, 'wx_375_375', {webp:true}, id)}
            onClick={() => props.onClick({ id,index,galleryid })}
          />
        );
      })}
    </div>
  );
};
export default inject('rootStore')(AllForColumn4);
